import {authInterceptor} from "../../auth/AuthInterceptor";
import { FrontEndClient } from '@eventfarm/javascript-sdk/dist/FrontEndClient';
import config from '../../../globals/config'

// export const apiBaseUrl = config.REACT_APP_API_BASE_URL;
export const apiBaseUrl = window.location.origin + '/api/v2';


const efClient = () => {
    const client = new FrontEndClient(
        "",
        apiBaseUrl,
        authInterceptor.intercept
        )
    return client;
};



export default efClient;
